<!-- 用户标签 -->
<template>
  <div class="user-tag">
    <h1 class="header">用户标签</h1>
    <!-- 主体内容呢 -->
    <div class="body">
      <!-- 左边的 -->
      <div class="item">
        <div class="top">
          <div class="title">人工标签</div>
          <a-button class="btn" @click="onEdit" type="link" size="small">
            <EditOutlined />
            编辑
          </a-button>
        </div>
        <div class="bottom">
          <div class="tag-left" v-for="label in patientLabels" :key="label.labelId">
            {{ label.labelName }}
          </div>
          <!-- <a-empty   v-if="patientLabels.length === 0"></a-empty> -->
          <EmptyText v-if="patientLabels.length === 0" />
        </div>
      </div>
      <!-- 右边的 -->
      <div class="item">
        <div class="top">
          <div class="title">
            系统标签
            <span class="tips">统计自注册起至当前时间的数据</span>
          </div>
        </div>
        <div class="bottom center-bottom">
          <div class="tag-right">
            <div class="tag-text">
              病程阶段
              <a-tooltip>
                <template #title>患者在该医生下的诊疗累计</template>
                <QuestionCircleFilled class="icon" />
              </a-tooltip>
            </div>
            <div class="text">
              <template v-if="disease.diseaseCnt">复诊{{ disease.diseaseCnt }}次</template>
              <template v-else>--</template>
            </div>
          </div>
          <div class="tag-right">
            <div class="tag-text">
              转化率
              <a-tooltip>
                <template #title>累计处方购买数除以处方开具数的处方购买率</template>
                <QuestionCircleFilled class="icon" />
              </a-tooltip>
            </div>
            <div class="text">
              <template v-if="info.recomBuyRate">
                {{ info.recomBuyRate }}
                ({{ info.recomBuyCnt }} / {{ info.recomCnt }})
              </template>
              <template v-else>--</template>
            </div>
          </div>
          <div class="tag-right">
            <div class="tag-text">
              已购客单价
              <a-tooltip>
                <template #title>累计患者平均购买处方单价</template>
                <QuestionCircleFilled class="icon" />
              </a-tooltip>
            </div>
            <div class="text">
              <template v-if="info.recomSalesRate">
                {{ info.recomSalesRate }}（累计{{ info.recomBuySales }}/{{ info.recomBuyCnt }}单）
              </template>
              <template v-else>--</template>
            </div>
          </div>
          <div class="tag-right">
            <div class="tag-text">
              累计售后金额
              <a-tooltip>
                <template #title>患者所有已退款售后金额及单数</template>
                <QuestionCircleFilled class="icon" />
              </a-tooltip>
            </div>
            <div class="text">
              <template v-if="info.accumReturnSales">
                {{ info.accumReturnSales }}
                <template v-if="info.accumReturnOrders">({{ info.accumReturnOrders }}单)</template>
              </template>
              <template v-else>--</template>
            </div>
          </div>
        </div>
      </div>
    </div>
    <a-modal @ok="handleOk" v-model:visible="labelModal.visible" title="人工标签">
      <div class="labelModal">
        <div v-for="item in labelModal.labels" :key="item.configGroupCode" class="labels">
          <div class="title">{{ item.configName }}</div>
          <div class="content">
            <a-radio-group :value="labelModal.form[item.configGroupCode]">
              <a-radio
                @click.prevent="handleRadioClick(item.configGroupCode, it.labelId)"
                v-for="it in item.labelDetail"
                :key="it.labelId"
                :value="it.labelId"
              >
                {{ it.configItem }}
              </a-radio>
            </a-radio-group>
          </div>
        </div>
      </div>
    </a-modal>
  </div>
</template>

<script setup>
import { getLabelConfig, saveBatch } from '@/api/patientFile'
import { EditOutlined, QuestionCircleFilled } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'
import { computed, reactive } from 'vue'
import { useStore } from 'vuex'
import EmptyText from '../../EmptyText.vue'
const store = useStore()
const patientLabels = computed(() => store.state.patientFile.info.patientLabels || [])
const info = computed(() => store.state.patientFile.info)
const disease = computed(() => store.state.patientFile.disease)
const doctorInfo = computed(() => store.state.patientFile.bindUser.doctorInfo)
// const patientType = computed(() => store.state.patientFile.patientType)
// const hasId = computed(() => info.value.ucPatientId && doctorInfo.value.ucDoctorId)
// const canEdit = computed(() => patientType.value === 0 || hasId.value)
const labelModal = reactive({
  visible: false,
  form: {},
  labels: []
})
const onEdit = () => {
  getLabelConfig().then(result => {
    // 创建动态表单
    result.forEach(item => {
      const key = item.configGroupCode
      const label = patientLabels.value.find(f => f.configGroupCode === item.configGroupCode)
      const val = label?.labelId || null
      labelModal.form[key] = val
    })
    labelModal.labels = result
    labelModal.visible = true
  })
}
const handleOk = () => {
  const params = {
    doctorId: doctorInfo.value?.doctorId || 0,
    ucDoctorId: doctorInfo.value?.ucDoctorId || 0,
    patientId: info.value.patientId || info.value.prePatientId,
    ucPatientId: info.value.ucPatientId || 0,
    labelMap: {
      ...labelModal.form
    }
  }
  saveBatch(params).then(async result => {
    message.success('操作成功')
    labelModal.visible = false
    labelModal.form = {}
    store.dispatch('patientFile/getInfo')
  })
}
// 再次点击已选项时取消选择
const handleRadioClick = (groupCode, labelId) => {
  const current = labelModal.form[groupCode]
  if (current === labelId) {
    labelModal.form[groupCode] = null
  } else {
    labelModal.form[groupCode] = labelId
  }
}
</script>

<style lang="scss" scoped>
.user-tag {
  .header {
    font-weight: 500;
    font-size: 16px;
    color: #333333;
  }
  .body {
    display: flex;
    .item {
      border-radius: 4px;
      background: #fafafa;
      margin-right: 24px;
      padding: 12px;
      width: 50%;
      height: 144px;
      &:last-child {
        margin-right: 0;
      }
      .top {
        display: flex;
        justify-content: space-between;
        margin-bottom: 12px;
        .title {
          font-size: 14px;
          color: #333333;
          .tips {
            margin-left: 8px;
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
        .btn {
          color: #014ea8;
        }
      }
      .bottom {
        height: calc(100% - 24px - 12px);
        overflow: auto;
        .tag-left {
          display: inline-block;
          padding: 2px 5px;
          background: #f0f0f0;
          font-weight: 400;
          font-size: 14px;
          color: #333333;
          border-radius: 2px;
          margin: 0 12px 8px 0;
        }
        .tag-right {
          flex-shrink: 0;
          display: inline-block;
          padding: 8px 10px;
          // border: 1px solid #d3d3d399;
          border-radius: 4px;
          min-width: 150px;
          margin-right: 12px;
          background: #fff;
          height: 100%;
          &:last-child {
            margin-right: 0;
          }
          .tag-text {
            margin-bottom: 6px;
            font-size: 14px;
            color: #666666;
            .icon {
              color: #ccc;
            }
          }
          .text {
            color: #333;
          }
        }
      }
      // 右侧需要自适应上下剧中
      .center-bottom {
        display: flex;
        align-items: center;
      }
    }
  }
}
.labelModal {
  height: 700px;
  overflow-y: auto;
  .labels {
    margin-bottom: 20px;
    margin-left: 5px;
    .title {
      font-weight: 500;
      font-size: 16px;
      color: #333333;
      margin-bottom: 12px;
    }
  }
}
</style>
